export const PacCostWrapperExample =  ()=>{
    return (
        <div className="container">
            <h2>使い方</h2>
            Pac Cost WrapperはコストをひとまとめにしたPacCostのラッパーのテーブルです  
            <p>
            <img src={`${process.env.PUBLIC_URL}/pac_cost_wrapper_example.png`}></img>
            </p>
        <p>この例では1ドローするPac Costを実行したあとさらにCost Nextで１ドローする処理を表しています </p>
            
        </div>
    )
}
